const ICONS = {
  tools: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M8.1 2.7a4.2 4.2 0 0 0 2.2 5.2l-4 4a1.2 1.2 0 0 0 0 1.7l.1.1a1.2 1.2 0 0 0 1.7 0l4-4a4.2 4.2 0 0 0 5.2 2.2l-2.5-2.5.3-2.5 2.5-.3 2.5 2.5a4.2 4.2 0 0 0-5.2-5.2l-4 4A4.2 4.2 0 0 0 8.1 2.7z" />
    </svg>
  ),
  shield: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M10 1.7 3.8 4.2v5.5c0 4.1 2.6 7.5 6.2 8.6 3.6-1.1 6.2-4.5 6.2-8.6V4.2L10 1.7zm0 3 3.8 1.5v3.5c0 2.8-1.6 5.2-3.8 6-2.2-.8-3.8-3.2-3.8-6V6.2L10 4.7z" />
    </svg>
  ),
  sync: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M10 2.5a7.5 7.5 0 0 1 6.4 3.6V3.7h1.8v5.4h-5.4V7.3h2.4A5.7 5.7 0 1 0 15.1 13h2a7.5 7.5 0 1 1-7.1-10.5z" />
    </svg>
  ),
  ellipsis: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <circle cx="5" cy="10" r="1.4" />
      <circle cx="10" cy="10" r="1.4" />
      <circle cx="15" cy="10" r="1.4" />
    </svg>
  ),
  code: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="m7.2 6.2-3.9 3.8 3.9 3.8 1.2-1.2L5.7 10l2.7-2.6-1.2-1.2zm5.6 0-1.2 1.2 2.7 2.6-2.7 2.6 1.2 1.2 3.9-3.8-3.9-3.8z" />
    </svg>
  ),
  printer: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M6 2.7h8v3H6v-3zm-1.8 4h11.6a2 2 0 0 1 2 2v4.6h-2.4v4H4.6v-4H2.2V8.7a2 2 0 0 1 2-2zm2 8.8h7.6V11H6.2v4.5z" />
    </svg>
  ),
  wifi: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M10 15.4a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8zm-3.2-2.2 1.1 1.1a2.8 2.8 0 0 1 4.2 0l1.1-1.1a4.4 4.4 0 0 0-6.4 0zm-2.3-2.3 1.1 1.1a7.5 7.5 0 0 1 8.8 0l1.1-1.1a9 9 0 0 0-11 0z" />
    </svg>
  ),
  bell: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M10 18.3a2.4 2.4 0 0 0 2.3-1.8H7.7A2.4 2.4 0 0 0 10 18.3zm6-3.4H4l1.2-1.2V9.2a4.8 4.8 0 0 1 3.6-4.7V4a1.2 1.2 0 0 1 2.4 0v.5a4.8 4.8 0 0 1 3.6 4.7v4.5l1.2 1.2z" />
    </svg>
  ),
  user: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M10 10.1a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8zm0 1.7c-3.5 0-6.4 1.8-6.4 4v1h12.8v-1c0-2.2-2.9-4-6.4-4z" />
    </svg>
  ),
  location: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M10 1.8a5.4 5.4 0 0 0-5.4 5.4c0 4.3 5.4 11 5.4 11s5.4-6.7 5.4-11A5.4 5.4 0 0 0 10 1.8zm0 7.6a2.2 2.2 0 1 1 0-4.4 2.2 2.2 0 0 1 0 4.4z" />
    </svg>
  ),
  phone: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M4.5 2.8h2.8l1.1 3.1-1.7 1.7a12 12 0 0 0 5.6 5.6L14 11.5l3.1 1.1v2.8a1.4 1.4 0 0 1-1.4 1.4C8.8 16.8 3.2 11.2 3.2 4.2a1.4 1.4 0 0 1 1.3-1.4z" />
    </svg>
  ),
  mail: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M2.6 4.5h14.8a1.3 1.3 0 0 1 1.3 1.3v8.4a1.3 1.3 0 0 1-1.3 1.3H2.6a1.3 1.3 0 0 1-1.3-1.3V5.8a1.3 1.3 0 0 1 1.3-1.3zm7.4 5.1 7.3-3.8H2.7L10 9.6z" />
    </svg>
  ),
  chevron: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="m6.2 7.6 3.8 3.8 3.8-3.8 1.2 1.2-5 5-5-5 1.2-1.2z" />
    </svg>
  ),
  trend: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="m3.2 12.8 4.2-4.2 3 3 5.4-5.4 1.2 1.2-6.6 6.6-3-3-3 3z" />
    </svg>
  ),
  send: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M2.2 3.4 18 10 2.2 16.6l.2-5 9.2-1.6-9.2-1.6z" />
    </svg>
  ),
  person: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M10 10.1a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8zm0 1.7c-3.5 0-6.4 1.8-6.4 4v1h12.8v-1c0-2.2-2.9-4-6.4-4z" />
    </svg>
  ),
  calendar: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M5.6 1.9h1.8v2.2h5.2V1.9h1.8v2.2h2a1.8 1.8 0 0 1 1.8 1.8v10.8a1.8 1.8 0 0 1-1.8 1.8H3.6a1.8 1.8 0 0 1-1.8-1.8V5.9a1.8 1.8 0 0 1 1.8-1.8h2V1.9zm10.8 6H3.6v8.8h12.8V7.9z" />
    </svg>
  ),
  tag: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M2.4 9.1V3.6h5.5l8.2 8.2a1.4 1.4 0 0 1 0 2l-2.3 2.3a1.4 1.4 0 0 1-2 0L2.4 9.1zm3-3.5a1.3 1.3 0 1 0 0 2.6 1.3 1.3 0 0 0 0-2.6z" />
    </svg>
  ),
  more: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <circle cx="10" cy="5" r="1.3" />
      <circle cx="10" cy="10" r="1.3" />
      <circle cx="10" cy="15" r="1.3" />
    </svg>
  ),
  filter: (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M2.4 3.6h15.2l-6.1 6.5v5.2l-3 1.4v-6.6L2.4 3.6z" />
    </svg>
  ),
};

function IconBadge({ icon, className = '' }) {
  return <span className={`icon-badge ${className}`.trim()}>{ICONS[icon] || null}</span>;
}

export default IconBadge;
